export const SEARCH_CATEGORIES = {
  GENERAL: 'General',
  FINANCIALS: 'Financials',
  TRANSACTION: 'Transaction',
  VALUATION: 'Valuation'
};

export const PROFILER_SEARCH_CATEGORIES = {
  ADVANCED_SEARCH_CRITERIA: 'Advanced search criteria'
};

export const PROFILER_INDUSTRY_CODES_SEARCH_CATEGORIES = {
  ADVANCED_SEARCH_CRITERIA: 'Advanced search criteria'
};
